export enum AdminDirectSystem {
    AdminDirect = "A",
    CallCenter = "C",
    Laptop = "L",
    SelfServe = "S",
    NotApplicable = "N",
    MyWorkplace = "M",
    ShopForBenefits = "V",
    Mobile = "P"
}

export const AdminDirectSystemLocation = {
    CallCenter: AdminDirectSystem.CallCenter,
    Laptop: AdminDirectSystem.Laptop,
    MyWorkplace: AdminDirectSystem.MyWorkplace
}